import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, ProgressBar } from 'react-materialize';
import * as actions from '../../actions';

import DatePicker from './DatePicker';
import PageDataTable from './PageDataTable';
import QueryDataTable from './QueryDataTable';
import LineChart from './LineChart';
import RadioSelect from './RadioSelect';
import SelectPosition from './SelectPosition';
import CountrySelect from './CountrySelect';
import PagePagination from './PagePagination';
import QueryPagination from './QueryPagination';
import SerpPreview from './SerpPreview';
import QueriesFiveWToggle from './QueriesFiveWToggle';
import DeviceSelect from './DeviceSelect';
import DatePresetSelect from './DatePresetSelect';
import PageSearch from './PageSearch';
import ChartToggle from './ChartToggle';
import PageSubscribeCta from './PageSubscribeCta';
import QueriesSubscribeCta from './QueriesSubscribeCta';
import SubscriptionModal from './SubscriptionModal';

import './style.css';

class Dashboard extends Component {
  componentDidMount() {
    this.props.fetchDates();
    this.props.fetchSites();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.props.history.push('/');
    }
  }

  renderSerpPreview() {
    if (this.props.chartToggle) return null;
    return (
      <Col s={12} m={12} l={6}>
        <SerpPreview />
      </Col>
    )
  }

  renderChart() {
    if (this.props.chartToggle) return null

    return (
      <Col s={12} m={12} l={6}>
        <LineChart />
      </Col>
    )
  }

  renderFullChart() {
    if (this.props.chartToggle) {
      return (
        <Col s={12} m={12} l={12}>
          <LineChart />
        </Col>
      )
    }

    return null;
  }

  renderExportLoading() {
    if (this.props.exportLoading) {
      return (
        <Col s={12}>
          <p>Please wait while we're exporting your data</p>
          <ProgressBar />
        </Col>
      )
    }

    return null;
  }

  renderPaymentConfirmation() {
    const handleOnClick = e => {
      e.preventDefault();

      this.props.hidePaymentConfirmation();
    };

    if (this.props.paymentConfirmation) {
      return (
        <div className="col s12 payment-confirmation">
          <div className="payment-confirmation_message">You have successfully subscribed to Page Outil!</div>
          <div className="payment-confirmation_hide">Click <a href="" onClick={handleOnClick}>here</a> to hide this message.</div>
        </div>
      )
    }

    return null;
  }

  renderUnsubscribeConfirmation() {
    const handleOnClick = e => {
      e.preventDefault();

      this.props.hideUnsubscribeConfirmation();
    };

    if (this.props.unsubscribeConfirmation) {
      return (
        <div className="col s12 unsubscribe-confirmation">
          <div className="unsubscribe-confirmation_message">Sorry to see you go :( You have unsubscribed to Page Outil.</div>
          <div className="unsubscribe_hide">Click <a href="" onClick={handleOnClick}>here</a> to hide this message.</div>
        </div>
      )
    }

    return null;
  }

  render() {
    return (
      <div className="dashboard-container">
        <Row>
          {this.renderUnsubscribeConfirmation()}
          {this.renderPaymentConfirmation()}
          {this.renderExportLoading()}
          <SubscriptionModal />
          <Col s={12} m={3} l={6}  className="hide-on-small-only">
            <DatePicker />
          </Col>
          <DatePresetSelect />
          <Col s={12} m={3} l={3}>
            <RadioSelect />
          </Col>
        </Row>
        <Row>
          { this.renderChart() }
          { this.renderFullChart() }
          { this.renderSerpPreview() }
        </Row>
        <Row>
          <PageSearch />
          <CountrySelect />
          <DeviceSelect />
            <ChartToggle />
          <Col s={6} m={6} l={2}>
            <QueriesFiveWToggle />
          </Col>
          <Col s={6} m={6} l={2}>
            <SelectPosition />
          </Col>
        </Row>
        <Row>
          <Col m={6} l={6} s={12} className="page-table">
            <PageDataTable />
            <PageSubscribeCta />
            <PagePagination />
          </Col>
          <Col m={6} l={6} s={12} className="query-table">
            <QueryDataTable />
            <QueriesSubscribeCta />
            <QueryPagination />
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps({
  loading,
  exportLoading,
  startDate,
  endDate,
  chartToggle,
  auth,
  error,
  exportData,
  paymentConfirmation,
  unsubscribeConfirmation
}) {
  return {
    loading,
    exportLoading,
    startDate,
    endDate,
    chartToggle,
    auth,
    error,
    exportData,
    paymentConfirmation,
    unsubscribeConfirmation
  };
}

export default connect(mapStateToProps, actions)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js